import {BBElement} from "../bb/classes/forms/elements/BBElement";
import {LoaderInterface} from "./LoaderInterface";

export class Loader implements LoaderInterface {

    private loader: BBElement
    private processCount: number

    constructor() {}

    public setLoader(loader: HTMLElement): void {
        this.processCount = 0;
        this.loader = new BBElement(loader);
        this.loader.addClass('bbloader');
    }

    private show() {
        this.loader.addClass('active');
    }

    private hide() {
        this.loader.removeClass('active');
    }

    public addProcess() {
        this.processCount++;
        this.show();
    }

    public removeProcess() {
        this.processCount--;
        if (this.processCount == 0) {
            this.hide();
        }
    }

}